"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBitwiseOpcodeTemplates = getBitwiseOpcodeTemplates;
function getBitwiseOpcodeTemplates() {
    return `
                        // Bitwise Operations
                        case opMap[20]: { // BIT_AND
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a & b);
                            pc++;
                            break;
                        }

                        case opMap[21]: { // BIT_OR
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a | b);
                            pc++;
                            break;
                        }

                        case opMap[22]: { // BIT_XOR
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a ^ b);
                            pc++;
                            break;
                        }

                        case opMap[23]: // BIT_NOT
                            stack.push(~stack.pop());
                            pc++;
                            break;

                        case opMap[24]: { // SHL
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a << b);
                            pc++;
                            break;
                        }

                        case opMap[25]: { // SHR
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a >> b);
                            pc++;
                            break;
                        }

                        case opMap[26]: { // USHR
                            let b = stack.pop();
                            let a = stack.pop();
                            stack.push(a >>> b);
                            pc++;
                            break;
                        }
    `;
}
